<template>
    <div class="d-flex flex-column">
        <navigator :selectedPerson="getSelectedPerson" :passedForm="getNewAgentSetup"></navigator>

        <steps :currentStep="currentStep" @changeCurrentStep="changeCurrentStep"></steps>

         <div class="new-agent flexGrow1">
            <component
                :is="stepTemplate"
                :currentStep="currentStep"
                :passedForm="getNewAgentSetup"
                :showExistingAgentSelector="isAcceptingConnection"
                v-bind:is-disabled="isDisabled"
                @formHaveErros="formHaveErros"
                @changeCurrentStep="changeCurrentStep"
                @cancelling="cancel"
                @goToNext="goToNext"
                @goToPrevious="goToPrevious"
                @readyToSave="readyToSave"
                @save="save">
            </component>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex'
    import Navigator from './AgentNavigator'
    import Steps from './AgentSteps'
    import AgentForm from './AgentForm'
    import AgentCommissionsWrapper from './AgentCommissionsWrapper'

    export default {
        data() {
            return {
                form: {},
                stepTemplate: 'AgentForm',
                currentStep: 1,
                isAcceptingConnection: false,
                setCommissionsData: null,
                isDisabled: true
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                const isFromNotification = vm.$store.state.notifications.isfromNotification;

                if (from.path === '/' && !isFromNotification) {
                    vm.$router.push({name: 'people'});
                    vm.clearSelectedPerson();
                }

                if (isFromNotification) vm.$store.commit('SET_IS_FROM_NOTIFICATION', false);
            });
        },
        created() {
            this.clearSelectedPerson();

            // If we are coming from a notification when an agent invites a supplier for a protocol
            if (this.$route.params.agentId) {
                this.setCommissionsData = this.$route.params;
            }
            this.checkIsAcceptingInvitation();

            this.eventHub.$on('setInvitationCommissions', (data) =>{
                this.currentStep = 1;
                this.stepTemplate = 'AgentForm';
                this.setCommissionsData = data;
                this.checkIsAcceptingInvitation();
            });

        },
        beforeDestroy() {
            this.eventHub.$off('setInvitationCommissions');
        },
        computed: {
            ...mapGetters([
                'getSelectedPerson',
                'getClonedAgent',
                'getNewAgentSetup'
            ]),
        },
        methods: {
            ...mapActions([
                'clearSelectedPerson',
                'clearClonedAgent',
                'updateClonedAgent',
                'addAgent',
                'updateAgent',
                'updateNewAgentSetup',
                'resetNewAgentSetup',
                'getAgentInfo'
            ]),
            checkIsAcceptingInvitation() {
                if (this.$route.params.agentId){
                    this.resetNewAgentSetup();
                    this.isAcceptingConnection = true;
                    this.getAgentInfo({
                        supplierId: this.setCommissionsData.supplierId,
                        agentId: this.setCommissionsData.agentId
                    }).then(response => {
                        if (response.status == 200) {
                            response.data.id = null;
                            response.data.notificationId = this.$route.params.notificationId;
                            // Edits existing
                            this.updateNewAgentSetup(response.data);
                        }
                    });
                }
            },
            changeCurrentStep(step) {
                let template = 'ProductEdit';
                this.currentStep = step;

                switch (step) {
                    case 1:
                        template = 'AgentForm';
                        break;
                    case 2:
                        template = 'AgentCommissionsWrapper';
                        break;
                    default:
                        break;
                }

                this.stepTemplate = template;
            },
            cancel() {
                this.clearSelectedPerson();
                this.$router.push({ name: 'agents' });
            },
            goToNext(data) {
                if (!data.$invalid) {
                    this.currentStep++;

                    // We'll use clonedAgent both for create and edit, so we can centralize the whole form in it
                    this.updateClonedAgent(data.form);
                    this.changeCurrentStep(this.currentStep);
                }
            },
            goToPrevious(data) {
                this.currentStep--;

                // We'll use clonedAgent both for create and edit, so we can centralize the whole form in it
                this.updateClonedAgent(data.form);
                this.changeCurrentStep(this.currentStep);
            },
            readyToSave(form) {
                this.updateClonedAgent(form);
            },
            formHaveErros(trueOrfalse) {
              this.isDisabled = trueOrfalse;
            },
            save(invite) {
                let vm = this;
                this.addAgent({
                    sendInvite: invite
                }).then(response => {
                    vm.$router.push({ name: 'agents' });
                });
            }
        },
        components: {
            Navigator,
            Steps,
            AgentForm,
            AgentCommissionsWrapper,
        }
    }
</script>

<style lang="scss" scoped>
    .new-agent {
        height: 78vh;
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// AgentNew.vue?0b43a72c